import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  VIEW_START,
  VIEW_SUCCESS,
  VIEW_FAILURE,
  SAVE_START,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  USERS_LOADED,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_FAILURE
} from './actions';

const initialState = {
  loading: false,
  corporations: [],
  users: [],
  corporation: null,
  saving: false
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case VIEW_START:
      newState.loading = true;
      newState.corporation = null;
      break;
    case VIEW_SUCCESS:
      newState.loading = false;
      newState.corporation = action.payload;
      break;
    case VIEW_FAILURE:
      newState.loading = false;
      newState.corporation = null;
      break;
    case LOAD_START:
      newState.loading = true;
      newState.corporations = [];
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.corporations = action.payload;
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      break;
    case SAVE_START:
      newState.saving = true;
      break;
    case SAVE_SUCCESS:
    case SAVE_FAILURE:
      newState.saving = false;
      break;
    case USERS_LOADED:
      newState.users = action.payload.filter(
        c => c.type.indexOf('corporation') === 0
      );
      break;
    case DELETE_START:
      newState.loading = true;
      break;
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      newState.loading = false;
      break;
    /*
      case REQUEST_START:
        newState.requesting = true;
        break;
      case REQUEST_SUCCESS:
        newState.requesting = false;
        newState.ask.partnerships = action.payload;
        break;
      case REQUEST_FAILURE:
        newState.requesting = false;
        break;
      */
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/corporations/reducer.js